var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { useRenameCSS } from "../theme/Theme.js";
/**
 * @deprecated
 * Use Box with padding and border instead
 * ```
 * <Box padding="4" borderRadius="small" />
 * <Box padding="4" borderWidth="1" borderRadius="small" />
 * ```
 * Component will be removed in a future major release
 */
export const Panel = forwardRef((_a, ref) => {
    var { children, className, border = false, as: Component = "div" } = _a, rest = __rest(_a, ["children", "className", "border", "as"]);
    const { cn } = useRenameCSS();
    return (React.createElement(Component, Object.assign({ ref: ref, className: cn("navds-panel", className, {
            "navds-panel--border": border,
        }) }, rest), children));
});
export default Panel;
//# sourceMappingURL=Panel.js.map